const PROBE_COOKIE = 'popp-cross-site-cookie-probe';

// Safari, Firefox and Chrome with third-party cookies blocked drop this write
// silently in a cross-site frame, so reading it back is the only reliable test.
// A sandboxed frame without allow-same-origin throws on document.cookie instead.
export const keepsCrossSiteCookies = (cookieDomain: string): boolean => {
  const attributes = `; domain=${cookieDomain}; path=/; SameSite=None; Secure`;
  try {
    document.cookie = `${PROBE_COOKIE}=1${attributes}`;
    const kept = document.cookie.split('; ').includes(`${PROBE_COOKIE}=1`);
    document.cookie = `${PROBE_COOKIE}=; max-age=0${attributes}`;
    return kept;
  } catch {
    return false;
  }
};
